import { useMemo } from "react";
import type { ShowLanguage } from "view/components/SettingsRows/ShowLanguagesRow/useShowLanguages";
import { useEffectiveShowLanguages } from "hooks/useEffectiveShowLanguages";

export const useTranslationLanguages = (showId?: string) => {
  const {
    translatable,
    defaultLanguage,
    isLoading,
  } = useEffectiveShowLanguages(showId);

  const languages: ShowLanguage[] = useMemo(
    () => translatable.filter((language) => !language.base),
    [translatable]
  );

  const languageCodes = useMemo(
    () => languages.map((language) => language.code),
    [languages]
  );

  return {
    languages,
    languageCodes,
    defaultLanguage,
    isLoading,
    hasLanguages: languages.length > 0,
  };
};

export default useTranslationLanguages;
